import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_PARTNER = 'add partner'
export const NAME = 'name'
export const COMPLETE_LINK = 'complete link'
export const SCREENED = 'Screened'
export const QUOTA_FULL = 'Quota full'
export const QUALITY_SCREENED = 'Quality Screened'
export const REQUIRED_FIELDS = 'required fields'
export const PARTNER_ADDED = 'partner added'

export default {
  [PORTUGUESE]: {
    [ADD_PARTNER]: 'Adicionar Parceiro',
    [NAME]: 'Nome',
    [COMPLETE_LINK]: 'Link Completo',
    [SCREENED]: 'Screened',
    [QUOTA_FULL]: 'Cota Completa / Quotafull',
    [QUALITY_SCREENED]: 'Filtrado por Qualidade',
    [REQUIRED_FIELDS]: 'Por favor preencha os campos obrigatórios',
    [PARTNER_ADDED]: 'Parceiro adicionado',
  },

  [ENGLISH]: {
    [ADD_PARTNER]: 'Add Partner',
    [NAME]: 'Name',
    [COMPLETE_LINK]: 'Complete Link',
    [SCREENED]: 'Screened',
    [QUOTA_FULL]: 'Quota full',
    [QUALITY_SCREENED]: 'Quality Screened',
    [REQUIRED_FIELDS]: 'Please fill in the required fields',
    [PARTNER_ADDED]: 'Partner added',
  },

  [SPANISH]: {
    [ADD_PARTNER]: 'Agregar Panel Externo',
    [NAME]: 'Nombre',
    [COMPLETE_LINK]: 'Link Completo',
    [SCREENED]: 'Screened',
    [QUOTA_FULL]: 'Cuota Completa / Quotafull',
    [QUALITY_SCREENED]: 'Filtrado por Calidad',
    [REQUIRED_FIELDS]: 'Por favor llene los campos requeridos',
    [PARTNER_ADDED]: 'Panel externo agregado',
  },
}
